import React from "react"

import styles from "./Grid.module.scss"

const Grid = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.grid}>{children}</div>
}

export default Grid
